<template>
  <div
    :class="[
      sellConfig.row_amount ? 'good-sell__layout--' + sellConfig.row_amount : 'good-sell__layout--3',
      sellConfig.mb_row_amount ? 'good-sell__layout-mb--' + sellConfig.mb_row_amount : 'good-sell__layout-mb--1',
    ]"
    class="good-sell"
    id="good-sell"
    style="width: 100%"
  >
    <!-- 卡片标题 -->
    <div
      class="good-sell__title"
      :style="{
        'background-color': cardConfig.background_color || 'rgba(245,185,35,1)',
        color: cardConfig.text_color || '#FFFFFF',
      }"
    >
      <span class="text-overflow-2 secondary_title">{{ cardConfig.title }}</span>
    </div>
    <!-- 卡片副标题 -->
    <div
      class="good-sell__subtitle page_text_font"
      :style="{
        'background-color': cardConfig.background_color
          ? halfOpacity
          : 'rgba(245,185,35,0.5)',
      }"
    >
      <span class="text-overflow-1">{{ cardConfig.sub_title }}</span>
      <!-- 折扣 -->
      <span v-if="sellConfig.show_discount" class="good-sell__discount">
        {{ computed_price.percentage ? `${computed_price.percentage}% OFF` : '' }}
      </span>
    </div>
    <!-- 图片 -->
    <a
      v-if="productDetail"
      class="columns"
      :href="sellConfig.enable_link ? productDetail.path || productDetail.public_url : null"
      :title="productDetail.post_title || productDetail.title"
    >
      <div class="product-item">
        <div class="product-media">
          <div :class="[card_radio || 'square']" class="product-media__img">
            <template>

              <v-lazy-img
                :src="(mix_now_image_data && mix_now_image_data.thumbnail) || defaultImage"
                :data-url="(mix_now_image_data && mix_now_image_data.url) || defaultImage"
                @error.once="imageFailure($event, defaultImage)"
                :alt="productDetail.post_title"
                class="img-fluid"
                :class="{ 'img-cover': card_img_style === 'cover' }"
                :style="{ backgroundColor: img_backgorund }"
              />
            </template>
            <v-product-tag
              v-if="$store.state.product_tag_list[productDetail.ID]"
              :productTag="$store.state.product_tag_list[productDetail.ID]"
              :productInfo="product_info"
            ></v-product-tag>
          </div>
          <!-- 销售标签 -->
          <template>
            <div
              v-if="!computed_price.buy_able && productDetail.ID"
              class="product-label venue_sales_label title_font2"
            >
              <p class="product-label__text text-uppercase">
                {{ $t('venue.productList.sold_out') }}
              </p>
            </div>
          </template>
        </div>
      </div>
    </a>
    <!-- 变种加购 -->

    <!-- 评论 -->
    <div class="good-sell__star ahtena_star">
      <span class="good-sell__star-num ahtena_star-num page_text_font"> {{ cardConfig.comment_num }} </span>
      <v-star
        v-if="cardConfig.comment_star"
        :disabled="true"
        :average_rating="cardConfig.comment_star"
        :font_size="16"
      ></v-star>
    </div>
    <!-- 价格 -->
    <p v-if="sellConfig.show_price" class="good-sell__price secondary_title">
      <v-selectprice
        v-if="computed_price.buy_able || theme == 'athena'"
        :price="computed_price.price"
        :font-size="16"
        :regular-font-size="14"
        :regular_price_num="computed_price.regular_price > computed_price.price && computed_price.regular_price"
        :disable_select="true"
        :country="$store.state.pricetype"
      ></v-selectprice>
    </p>
    <!-- 数量 -->
    <div class="good-sell__qtm">
      <select name id v-model="add_cart_data.quantity">
        <option v-for="item in [1, 2, 3, 4, 5]" :key="item" :value="item">{{ item }}</option>
      </select>
    </div>

    <!-- 加购按钮 -->
    <div class="good-sell__btn secondary_title">
      <v-add-card-btn
        :theme="theme"
        :cart_type="cart_type"
        :product_res="product_res"
        :variant_attrs="variant"
        :computed_price="computed_price"
        @showMobileAddCartPopup="showMobileAddCartPopup(productDetail, cardConfig)"
        @clickAdd="add_cart('buynow')"
        :btn-text="cardConfig.btn_text || 'BUY IT NOW'"
        v-if="product_res.ID && stock"
      ></v-add-card-btn>
      <div v-else class="good-sell__btn__soldout">
        <button class="soldout cursor-default">
          <span class="text-uppercase add"> {{ $t('detail.sold_out') }}</span>
        </button>
      </div>
    </div>
    <!-- 安全信息 -->
    <div v-if="sellConfig.show_safe" class="good-sell__secure">Secured And Encrypted</div>
  </div>
</template>

<script>
import vStar from '@/js/components/view/comments/commentsstar'
import vProductPalette from '@/js/components/view/productpalette/index'
import mixProductTag from '@/js/mixins/mixProductTag'
import vAddCardBtn from '@/js/components/common/addCardBtn.vue'
import mixProduct from '@/js/mixins/mixProduct'
import mixAdd from '@/js/mixins/mixAdd'
import vDiscountTag from '@/js/components/common/discountTag.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import { mapState } from 'vuex'

export default {
  props: {
    // 商品数据
    productDetail: {
      type: Object,
      default: null,
    },
    // 主题
    theme: {
      type: String,
      default: null,
    },
    // 卡片配置
    cardConfig: {
      type: Object,
      default: null,
    },
    // 商品推售配置
    sellConfig: {
      type: Object,
      default: null,
    },
  },
  mixins: [mixAdd, mixProduct, mixProductTag],
  data() {
    return {
      price: 0,
      regularPrice: 0,
      stock: true,
      cardStyle: {},
      disabled: false,
      selected_variant: [],
      variant_src_id: null,
      productImageData: this.productDetail?.gallery?.[0] || {},
      product: {},
      product_res: {},
      now_variant: {},
      add_cart_data: {
        product_id: null,
        quantity: 1,
      },
      cart_type: 'drawer',
      pageSize: 0,
      screenWidth: 0,
      addType:'goodSell',
    }
  },
  methods: {
    combineSize() {
      let combineWidth = this.$(window).width() > 768 ? 67 : 50
      if (this.$('div.combine').length > 0) {
        this.screenWidth = this.$(window).width()
        let nexSize = this.$('div.product_details').width() / combineWidth
        if (this.pageSize != nexSize) {
          this.pageSize = nexSize
        }
      }
    },
  },
  beforeMount() {
    this.screenWidth = document.body.clientWidth
  },
  mounted() {
    this.combineSize()
    window.addEventListener('resize', () => {
      this.combineSize()
    })
    this.$el.style.setProperty('--el-background', this?.cardConfig?.background_color)
    this.$el.style.setProperty('--el-color', this?.cardConfig?.text_color)
  },
  computed: {
    // 计算属性的 getter
    preferential_percentage: function () {
      if (this.regularPrice < this.price) {
        return 0
      } else {
        return Math.ceil((1 - this.price / this.regularPrice) * 100)
      }
    },
    preferential_fix: function () {
      if (this.regularPrice < this.price) {
        return 0
      } else {
        return (this.regularPrice - this.price).toFixed(2)
      }
    },
    // 颜色透明度减半处理
    halfOpacity() {
      let op = this.cardConfig.background_color.match(/rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(,([.\d]+))?\)/);
      if(op?.[5]) {
        let opHalf = (Number(op[5]) / 2).toFixed(2) ;
        return `rgba(${op[1]},${op[2]},${op[3]},${opHalf})`
      }
      return this.cardConfig.background_color;
    },
    ...mapState({
      img_backgorund: ({ options }) => options?.theme?.global?.colors?.img_backgorund,
      card_img_style: ({ options }) => options?.theme?.global?.product_cart?.card_img_style,
      card_title_style: ({ options }) => options?.theme?.global?.product_cart?.card_title_style,
      card_radio: ({ options }) => options?.theme?.global?.product_cart?.card_radio,
    }),
    containStyle() {
      if (this.card_img_style === 'cover') {
        return {
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundColor: this.img_backgorund || '#FFFFFF',
        }
      }
      return {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundColor: this.img_backgorund || '#FFFFFF',
      }
    },
  },
  watch: {
    productDetail: {
      handler(newV) {
        this.product = this.productDetail
        this.add_cart_data.product_id = newV.ID
        let copy_product = JSON.stringify(newV)
        this.product_res = JSON.parse(copy_product)
        this.now_variant = JSON.parse(copy_product)
        if (newV.variant_attrs && newV.variant_attrs.length) {
          this.create_attrs()
        }
        const { variants_detail, regular_price, price, min_price, buy_able } = newV
        if (variants_detail && variants_detail.length > 0) {
          const filterMinProduct = variants_detail.filter((item) => item.price == min_price)
          if (filterMinProduct) {
            filterMinProduct.sort(function (a, b) {
              return a.regular_price - b.regular_price
            })
          }
          this.price = (min_price && Number(min_price)) || 0
          this.regularPrice =
            (filterMinProduct && filterMinProduct[0] && Number(filterMinProduct[0].regular_price)) || 0
        } else {
          this.price = (price && Number(price)) || 0
          this.regularPrice = regular_price && regular_price > price ? Number(regular_price) : 0
        }
        if (buy_able) {
          this.stock = true
        } else {
          this.stock = false
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    vStar,
    vProductPalette,
    vAddCardBtn,
    vDiscountTag,
    vProductTag,
  },
}
</script>

<style scoped lang='scss'>
.good-sell {
  text-align: center;
  border-radius: 12px 12px 0px 0px;
  margin-bottom: 20px;
  &__title {
    padding: 14px 20px;
    font-weight: bold;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__subtitle {
    padding: 14px 20px;
    min-height: calc(22px + 28px);
    span {
      display: block;
      &:nth-child(1) {
        height: 22px;
      }
    }
  }
  &__discount {
    margin-top: 10px;
    font-weight: bold;
  }
  &__star {
    margin-top: 14px;
    min-height: 24px;
    &::v-deep .starWrap {
      font-size: 24px;
      .el-rate {
        height: auto;
        margin-right: 5px;
        .el-rate__icon,
        .el-icon-star-on {
          color: black !important;
          font-size: 18px !important;
        }
        &__decimal {
          color: #000000 !important;
        }
      }
    }
    &-num {
      font-size: 14px;
    }
  }
  &__btn {
    &::v-deep {
      .add-btn-box {
        margin-top: 10px;
      }
      .add-card-div,
      .select-div-box {
        .add-card-btn {
          border-radius: 4px;
          padding: 12px 14px;
          min-height: 50px;
          .add {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-transform: none !important;
            color: var(--el-color);
            font-weight: bold;
          }
          &:hover .add {
            color: var(--main-btn-bg);
          }
          .select {
            .plus {
              right: 1px;
              top: 12px;
            }
          }
        }
        select {
          border-radius: 4px;
          padding: 12px 14px !important;
          font-size: 16px;
          height: 50px;
          margin-bottom: 10px;
        }
        .add-btn {
          button {
            min-height: 50px !important;
            border-radius: 4px;
          }
        }
      }
    }
    &__soldout {
      width: 100%;
      button {
        text-align: center;
        width: 100%;
        font-size: 16px;
        min-height: 50px;
        padding: 10px;
        outline: none;
        line-height: 1.2;
        border-radius: 4px;
      }
    }
  }
  &__qtm {
    position: relative;
    margin-top: 20px;
    select {
      position: relative;
      list-style: none;
      direction: ltr;
      box-sizing: inherit;
      font-size: 100%;
      margin: 0;
      text-transform: none;
      display: block;
      border-radius: 4px;
      height: 50px;
      line-height: 22px;
      padding: 12px;
      color: #1e0909;
      border: 1px solid #e4e4e4;
      width: 100%;
      margin-bottom: 12px;
      cursor: pointer;
      font-weight: 400;
      background: rgba(255, 255, 255, 0.8);
      padding-left: 14px !important;
      font-family: 'Roboto', sans-serif;
      border-color: rgba(17, 17, 17, 0.2);
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding-right: 30px;
      transition: 0s;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &::after {
      content: '\E62A';
      font-family: 'iconfont';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 14px;
      font-size: 15px;
      color: rgba(17, 17, 17, 0.4);
      pointer-events: none;
    }
  }
  &__secure {
    margin-top: 14px;
    &::before {
      content: '\e608';
      font-family: 'iconfont';
      color: #3fc6ad;
      margin-right: 5px;
    }
  }
  &__price {
    font-weight: bold;
    &::v-deep {
      .selectpricewrap {
        line-height: unset;
      }
    }
  }
}

.good-sell__layout {
  &--3 {
    .good-sell {
      &__title {
        font-size: 24px;
        line-height: 34px;
        height: calc(68px + 28px);
      }
      &__subtitle {
        font-size: 18px;
        line-height: 24px;
      }
      &__discount {
        font-size: 24px;
        line-height: 24px;
        height: 24px;
      }
      &__price {
        margin-top: 14px;
        &::v-deep {
          .price_text,
          .regular_price_text {
            font-size: 20px !important;
            span {
              &:nth-child(2) {
                display: none;
              }
            }
          }
          .product_price_cross {
            margin-left: 0 !important;
          }
        }
      }
    }
  }

  &--4 {
    .good-sell {
      &__title {
        font-size: 20px;
        line-height: 30px;
        height: calc(60px + 28px);
      }
      &__subtitle {
        font-size: 16px;
        line-height: 24px;
      }
      &__discount {
        font-size: 20px;
        line-height: 20px;
        height: 20px;
      }
      &__price {
        margin-top: 14px;
        &::v-deep {
          .price_text,
          .regular_price_text {
            font-size: 18px !important;
            span {
              &:nth-child(2) {
                display: none;
              }
            }
          }
          .product_price_cross {
            margin-left: 0 !important;
          }
        }
      }
    }
  }

  &--5 {
    .good-sell {
      &__title {
        font-size: 16px;
        line-height: 26px;
        height: calc(52px + 28px);
      }
      &__subtitle {
        font-size: 14px;
        line-height: 24px;
      }
      &__discount {
        font-size: 16px;
        line-height: 16px;
        height: 16px;
      }
      &__price {
        margin-top: 14px;
        &::v-deep {
          .price_text,
          .regular_price_text {
            font-size: 16px !important;
            span {
              &:nth-child(2) {
                display: none;
              }
            }
          }
          .product_price_cross {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
}

#good-sell {
  .good-sell__btn {
    &::v-deep {
      .add-card-btn {
        border: 1px solid var(--el-background) !important;
        &::before {
          background-color: var(--el-background) !important;
        }
      }
    }
  }
}

.columns {
  .product-media__img {
    width: 100%;
    padding-top: 100%;
    position: relative;

    .img-fluid {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain !important;
      backface-visibility: hidden;
      transition: all 0.3s ease-in-out;
    }

    .img-cover {
      object-fit: cover !important;
    }

    &--hover {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-size: cover;
      background-position: center;
      opacity: 0;
      padding: 0 15px 0 0;
      visibility: hidden;
      transition: all 0.2s ease-in;
    }
  }
  .square {
    padding-top: 100% !important;
  }

  .horizon {
    padding-top: 75% !important;
  }

  .vertical {
    padding-top: 133% !important;
  }

  .vertical2 {
    padding-top: 150% !important;
  }
  .auto {
    padding-top: unset !important;
    .img-fluid {
      position: relative !important;
      display: block;
    }
  }
}

a {
  .product-item {
    width: 100%;
    break-inside: avoid;
    .product-media {
      width: 100%;
      box-sizing: inherit;
      position: relative;
      min-height: 100px;
      .product-label {
        position: absolute;
        background: #d34a4a;
        top: 12px;
        right: -6px;
        padding: 6px 18px;
        z-index: 1;

        &__text {
          line-height: 26px;
          color: #fff;
          font-family: 'oswald', sans-serif;
          letter-spacing: 1px;
          font-size: 13px;
          font-weight: 400;
          margin: 0;
        }
      }
    }
  }
  .product-item {
    .product-media:hover {
      .product-media__img {
        .img-fluid {
          opacity: 0.9;
        }

        &--hover {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .good-sell__layout-mb {
    &--1 {
      .good-sell {
        &__title {
          font-size: 18px;
          line-height: 23px;
          height: calc(42px + 30px);
        }
        &__subtitle {
          font-size: 15px;
          line-height: 16px;
          span {
            &:nth-child(1) {
              height: 15px;
            }
          }
        }
        &__discount {
          font-size: 24px;
          line-height: 24px;
          height: 24px;
        }
        &__star {
          margin-top: 14px;
          min-height: 24px;
          &::v-deep .starWrap {
            font-size: 24px;
            .el-rate {
              height: auto;
              margin-right: 5px;
              .el-rate__icon,
              .el-icon-star-on {
                color: black !important;
                font-size: 18px !important;
              }
            }
          }
          &-num {
            font-size: 15px;
          }
        }
        &__price {
          margin-top: 10px;
          &::v-deep {
            .price_text,
            .regular_price_text {
              font-size: 18px !important;
              span {
                &:nth-child(2) {
                  display: none;
                }
              }
            }
            .product_price_cross {
              margin-left: 0 !important;
            }
          }
        }
        &__secure {
          margin-top: 14px;
        }
        &__btn {
          &::v-deep {
            .add-card-btn {
              line-height: 42px;
              min-height: unset;
              padding: 0 10px;
              .add {
                font-size: 15px;
              }
            }
          }
          &__soldout {
            button {
              min-height: 44px;
            }
          }
        }
        &__qtm {
          margin-top: 10px;
          select {
            height: 44px;
            line-height: 20px;
            font-size: 15px;
          }
        }
      }
    }
    &--2 {
      .good-sell {
        &__title {
          font-size: 18px;
          line-height: 20px;
          height: calc(38px + 20px);
        }
        &__subtitle {
          font-size: 14px;
          line-height: 17px;
          span {
            &:nth-child(1) {
              height: 14px;
            }
          }
        }
        &__discount {
          font-size: 18px;
          line-height: 21px;
          height: 18px;
        }
        &__star {
          margin-top: 10px;
          min-height: 12px;
          &::v-deep .starWrap {
            font-size: 16px;
            .el-rate {
              height: auto;
              margin-right: 5px;
              .el-rate__icon,
              .el-icon-star-on {
                color: black !important;
                font-size: 13px !important;
              }
            }
          }
          &-num {
            font-size: 10px;
          }
        }
        &__price {
          margin-top: 10px;
          &::v-deep {
            .price_text,
            .regular_price_text {
              font-size: 15px !important;
              span {
                &:nth-child(2) {
                  display: none;
                }
              }
            }
            .product_price_cross {
              margin-left: 0 !important;
            }
          }
        }
        &__secure {
          margin-top: 10px;
          font-size: 12px;
        }
        &__btn {
          &::v-deep {
            .add-card-btn {
              line-height: 42px;
              min-height: unset;
              padding: 0 10px;
              .add {
                font-size: 14px;
              }
            }
          }
          &__soldout {
            button {
              min-height: 44px;
            }
          }
        }
        &__qtm {
          margin-top: 10px;
          select {
            height: 44px;
            line-height: 15px;
          }
        }
      }
    }
  }
  .product-item {
    margin-bottom: 15px !important;
    .product-label {
      padding: 2px 6px !important;
      &__text {
        font-size: 12px !important;
      }
    }
  }
}
</style>
